import { object } from "prop-types"
import { Date } from "source/shared/DatetimeFmt"
import { Heading } from "@planningcenter/doxy-web"
import { useOrganizationFlag } from "source/registrations/hooks/useOrganization"

const Header = ({ registration }) => {
  const canUseUnifiedConfirmationPage = useOrganizationFlag(
    "unifiedConfirmationPage",
  )

  return (
    <header
      className="mb-3"
      css={{
        borderBottom: canUseUnifiedConfirmationPage
          ? "1px solid var(--color-tint5)"
          : "",
      }}
    >
      {registration.isDetailed ? (
        <h2 className="mb-1">
          Thanks! Your registration for&nbsp;
          <a href={registration.event.publicUrl}>{registration.event.name}</a>
          &nbsp; has been submitted.
        </h2>
      ) : (
        <Heading level={1} text={`Registration #${registration.id}`} />
      )}

      {registration.isDetailed ? (
        <p>
          A confirmation has been sent to{" "}
          {registration.responsiblePerson.emailAddress}. Your registration
          details are below.
        </p>
      ) : (
        <>
          <div className="mt-1">
            <a href={registration.event.publicUrl}>{registration.event.name}</a>
          </div>
          <div>
            {registration.event.startsAt && (
              <Date
                start={registration.event.startsAt}
                end={registration.event.endsAt}
                style="standard"
                year
              />
            )}
          </div>
        </>
      )}
    </header>
  )
}

Header.propTypes = {
  registration: object,
}

export default Header
